/* eslint-disable max-len */
export default function EMSuccessionPlanningController(
  $rootScope,
  $scope,
  $q,
  alerts
) {
  const vm = this;

  vm.getAutocompleteItemClass = _getAutocompleteItemClass;
  vm.handleSuccessorResourceChange = _handleSuccessorResourceChange;

  _activate();

  /** **************************************************
   * Event Handlers
   */
  function _getAutocompleteItemClass(item) {
    if (!item) {
      return '';
    }
    return item.isVendor ? 'vendor' : 'person';
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    vm.primarySuccessorOptions = _getPrimarySuccessors();
  }

  function _getPrimarySuccessors() {
    if (vm.successorOptions && vm.successorOptions.length > 0) {
      return vm.successorOptions.filter(item => !item.isVendor);
    }
  }

  function _handleSuccessorResourceChange(acvm) {
    const item = acvm.selectedItem;
    const position = acvm.position;

    const isPrimaryResource = (vm.successions.primary !== undefined) && (vm.successions.primary !== null) && (item !== null)
      && (((vm.successions.primary.vendorId !== null) && (vm.successions.primary.vendorId !== undefined) && (vm.successions.primary.vendorId === item.vendorId))
        || ((vm.successions.primary.userId !== null) && (vm.successions.primary.userId !== undefined) && (vm.successions.primary.userId === item.userId)));

    const isSecondaryResource = (vm.successions.alternate !== undefined) && (vm.successions.alternate !== null) && (item !== null)
      && (((vm.successions.alternate.vendorId !== null) && (vm.successions.alternate.vendorId !== undefined) && (vm.successions.alternate.vendorId === item.vendorId))
        || ((vm.successions.alternate.userId !== null) && (vm.successions.alternate.userId !== undefined) && (vm.successions.alternate.userId === item.userId)));

    const isTertiaryResource = (vm.successions.tertiary !== undefined) && (vm.successions.tertiary !== null) && (item !== null)
      && (((vm.successions.tertiary.vendorId !== null) && (vm.successions.tertiary.vendorId !== undefined) && (vm.successions.tertiary.vendorId === item.vendorId))
        || ((vm.successions.tertiary.userId !== null) && (vm.successions.tertiary.userId !== undefined) && (vm.successions.tertiary.userId === item.userId)));

    if (position === 'primary') {
      if (isSecondaryResource) {
        alerts.error('The Primary Successor Resource cannot be the same as the Secondary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Primary Successor Resource cannot be the same as the Tertiary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'secondary') {
      if (isPrimaryResource) {
        alerts.error('The Alternate Successor Resource cannot be the same as the Primary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isTertiaryResource) {
        alerts.error('The Alternate Successor Resource cannot be the same as the Tertiary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    } else if (position === 'tertiary') {
      if (isPrimaryResource) {
        alerts.error('The Tertiary Successor Resource cannot be the same as the Primary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      } else if (isSecondaryResource) {
        alerts.error('The Tertiary Successor Resource cannot be the same as the Secondary Successor Resource. Please choose a different option.');
        acvm.selectedItem = null;
      }
    }
  }
}

EMSuccessionPlanningController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
];
